import { render, staticRenderFns } from "./ExamHistory.vue?vue&type=template&id=f76aadf0&scoped=true&"
import script from "./ExamHistory.vue?vue&type=script&lang=js&"
export * from "./ExamHistory.vue?vue&type=script&lang=js&"
import style0 from "./ExamHistory.vue?vue&type=style&index=0&id=f76aadf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76aadf0",
  null
  
)

export default component.exports